// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","borderGrey":"#d5dfdf","infoGray":"#888888","smallMaxWidth":"991px","mobileThreshold":"575px","container":"iw66NEiRVlpEGvJDnLhw-","phone":"_3hhhFablmKBIhU1Xj6pocZ _2lYHSCAcM6vA2s-47YYZeS","containerInfo":"jgQMQMFrfztZlZCHRvaur","phoneInfo":"tK1vJOkDP8pMbdEeTS7tb","deleteButton":"ieLGcHIP0g-XRGhSNnP7J"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/my-account/phone-card/PhoneCard.css
// module id = 564
// module chunks = 0 1 2